/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./digitalTwinMap.vue?vue&type=template&id=522b9d28&scoped=true"
import script from "./digitalTwinMap.vue?vue&type=script&lang=js"
export * from "./digitalTwinMap.vue?vue&type=script&lang=js"
import style0 from "./digitalTwinMap.vue?vue&type=style&index=0&id=522b9d28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522b9d28",
  null
  
)

export default component.exports